
<script setup>
    import { reactive, ref, onMounted } from 'vue'
    import { ref as databaseRef, onValue, update, orderByChild, child, set, get } from "firebase/database";
    import { useRoute } from 'vue-router'
    import { formatToTimeZone } from 'date-fns-timezone';
    import HeaderComponent from "../../components/common/HeaderComponent.vue"
    import NavigationBar from '../../components/business/NavigationBar.vue'
    import EditPlanComponent from '../../components/business/EditPlanComponent.vue'
    import EditPersonComponent from '../../components/business/EditPersonComponent.vue'
    import EditPayComponent from '../../components/business/EditPayComponent.vue'
    import DefaultModalComponent from '../../components/common/DefaultModalComponent.vue'
    import Firebase from "../../firebase_settings/index.js"
    import utilFunctions from "../../firebase_settings/utils.js"
    import Error from "../../firebase_settings/error.js"
    import { loadStripe } from "@stripe/stripe-js";

    const DATEFORMAT = 'YYYY/MM';
    const TIME_ZONE_TOKYO = 'Asia/Tokyo';
    const auth = Firebase.auth
    const database = Firebase.database;
    const route = useRoute()

    //企業情報等のリアクティブオブジェクト
    const reactiveObj = reactive({
        //企業ID
        corporateId: '',
        //企業情報
        corporateObject: {},
        //編集した契約担当者情報
        editCorporateInfo: {},
        //再描画用のキー
        renderKey: 0,
        //モーダルに表示するメッセージ
        modalMessage: '',
        //ローディングフラグ
        loadingFlag: false,
        //ローディングフラグ(カード登録処理用)
        loadindCardFlag :false,
        //描画時のデータロード判定フラグ
        dataLoadFlag: false,
        //通常モーダルフラグ
        modalFlag: false,
        //契約担当者情報のモーダルフラグ
        personModalFlag: false,
        modalRenderkey: false,
        //プラン情報のモーダルフラグ
        planModalFlag: false,
        //プラン情報
        planInfo: {},
        //モーダル表示の追加オブジェクト
        otherObject: {
            //同意有無
            confirm: '',
            //モーダルの幅
            modalWidth: '',
        },
        //支払方法のモーダルフラグ
        payModalFlag:false,
    })

    const tipsPayFlag = ref(false)
    const isInvoicePayment = () => !(reactiveObj.dataLoadFlag && reactiveObj.corporateObject.PayKind)

    const paykindDict = {
        0: '請求書払い',
        1 : 'クレジットカード払い',
        2 : '口座振替',
    }
    //Stripeオブジェクト
    let stripeObj = {
        Stripe:null,
        cardNumberElement: null,
        cardExpiryElement: null,
        cardCvcElement: null,
        CardName :""
    }
    const stripe_pubkey = process.env.VUE_APP_STRIPE_PUBKEY;
    
    //firebaseから企業データを取得
    const getCorporate = async(CorporateId) => {
        return new Promise(async (resolve, reject) => {
            //企業コードが読み込めている場合
            if(CorporateId) {
                const addKey = { CorporateId }
                //DBの取得したいパスを指定
                const getData = databaseRef(database, `CorporateId/${CorporateId}/CorporateInfo`)
                //DBを取得
                onValue(getData, (snapshot) => {
                    if(snapshot.exists() && snapshot.val().ServiceFlag) {
                        const planValue = snapshot.val().PlanValue
                        reactiveObj.NextPlanValue = planValue + 1 < Object.keys(reactiveObj.planInfo).length
                        addKey['remainingUserCount'] = reactiveObj.planInfo[planValue].LimitUserCount - snapshot.val().UserCount
                        addKey['remainingTerminalCount'] = reactiveObj.planInfo[planValue].LimitTerminalCount - snapshot.val().TerminalCount
                        addKey['limitUserFlag'] = addKey['remainingUserCount'] < reactiveObj.planInfo[planValue].AlertUserCount
                        addKey['limitTerminalFlag'] = addKey['remainingTerminalCount'] < reactiveObj.planInfo[planValue].AlertTerminalCount
                        reactiveObj.corporateObject = Object.assign(snapshot.val(), addKey)
                        reactiveObj.dataLoadFlag = true
                    }
                })
                resolve()
            }
        });
    }
    
    //Stripeオブジェクトの初期化
    const initStripe = async () => {
        const base = {
            color: "#3f3f3f",
            fontSize: '14px',
        }
        stripeObj.Stripe = await loadStripe(stripe_pubkey);

        // Stripe Elementを作成
        const elements = stripeObj.Stripe.elements();
        // 各要素を作成
        stripeObj.cardNumberElement = elements.create("cardNumber", {
            placeholder:"スペースを開けずにご入力ください",
            disableLink:true,
            showIcon: true,
            style:{
                base:base
            }
        });
        stripeObj.cardExpiryElement = elements.create("cardExpiry", {
            placeholder:"Month/Year",
            style:{
                base:base
            }
        });
        stripeObj.cardCvcElement = elements.create("cardCvc", {
            placeholder:"数字3桁",
            style:{
                base:base
            }
        });
    }

    //Stripeのカード登録処理
    const registStripe = async () => {
        try {
            // Firebase Functionsで顧客登録
             const result = await utilFunctions.callFirebaseFunction('registCustomer', {
                corporateId: reactiveObj.corporateId,
                userName: reactiveObj.corporateObject.ContractPerson,
                adminEmail: reactiveObj.corporateObject.Email,
            });
            // Stripeでカードセットアップ(支払情報の登録)
            const setupResult = await stripeObj.Stripe.confirmCardSetup(result.data.clientSecret, {
                payment_method: {
                    card: stripeObj.cardNumberElement, // cardNumber Elementを渡す
                    billing_details: {
                        name: stripeObj.CardName,
                    }
                }
            },{return_url:`${window.location.origin}/contractinformation`});

            if(setupResult.error){
                console.log(setupResult.error)
                return false;
            }
            // 3DS対応が必要な場合、3DSをページ内モーダル(オーバーレイ)で表示
            if (setupResult.setupIntent.status === 'requires_action') {
                // Hosted flowへリダイレクト
                window.location.href = setupResult.setupIntent.next_action.redirect_to_url.url;
            }
            if (setupResult.setupIntent.status === 'succeeded') {
                // Firebase Functionsでクレジットカード情報を登録
                await utilFunctions.callFirebaseFunction('attachCardInfo', {
                    corporateId: reactiveObj.corporateId,
                    kind: reactiveObj.otherObject.payKind,
                    pmId: setupResult.setupIntent.payment_method
                });
                return true;
            }

        } catch (error) {
            console.error("Error in registStripe:", error);
            return false;
        }
    };

    // 次回支払料金の設定(年払い)
    const setNextPriceYearPay = async(currentDate, nextPayDate) => {
        // 旧プランの月割りの値段を求める
        const price12DivMonth = reactiveObj.planInfo[reactiveObj.editCorporateInfo.PlanValue - 1].Price12 / 12

        // 翌月が次回支払月の時、料金は 旧プランの1か月分の値段 + 新プランの値段 
        if((currentDate.getFullYear() == nextPayDate.getFullYear()) &&
             (currentDate.getMonth() + 1 == nextPayDate.getMonth()))
        {
            return reactiveObj.planInfo[reactiveObj.editCorporateInfo.PlanValue].Price12 + (price12DivMonth * 1)
        }
        // 当月が支払月の時、料金は旧プランの2か月分の値段 + 新プランの値段
        else if((currentDate.getFullYear() == nextPayDate.getFullYear()) &&
             (currentDate.getMonth() == nextPayDate.getMonth()))
        {
            return reactiveObj.planInfo[reactiveObj.editCorporateInfo.PlanValue].Price12 + (price12DivMonth * 2)
        }
        // 通常は新プランの料金 - 旧プランの残りの月の料金
        else{
            // 残りの月数を求める
            const diffMonths = (nextPayDate.getFullYear() - currentDate.getFullYear()) * 12
                 + (nextPayDate.getMonth() - currentDate.getMonth()) - 2; // 利用開始月+翌月支払月の月数が含まれているのでマイナスする
            return reactiveObj.planInfo[reactiveObj.editCorporateInfo.PlanValue].Price12 - (diffMonths * Math.floor(price12DivMonth))
        }
    }

    //契約担当者情報のモーダルを表示
    const showPersonModal = () => {
        reactiveObj.personModalFlag = true
        reactiveObj.renderKey++
    }
    //契約担当者情報のモーダルを閉じる
    const closePersonModal = (editFlag, PersonObject) => {
        reactiveObj.personModalFlag = false
        //変更の有無
        if(editFlag) {
            //変更したい値を格納
            reactiveObj.editCorporateInfo = PersonObject
            //変更があればその値を更新、なければ変更なし
            const ContractPerson = PersonObject.ContractPerson ? PersonObject.ContractPerson : '変更なし'
            const Email = PersonObject.Email ? PersonObject.Email : '変更なし'
            reactiveObj.modalMessage = `下記の内容に変更します。よろしいですか？<br><br>ご担当者様：${ContractPerson}<br>メールアドレス：${Email}`
            reactiveObj.otherObject.confirm = 'OK'
            showDefaultModal()
            reactiveObj.renderKey++
        }
    }

    // 今月の支払前にプランを変更していないか判定
    const chkPlanChgCount = () => {
        // 更新履歴一覧を取得
        const contractHistoryPath = `CorporateId/${reactiveObj.corporateId}/CorporateInfo/ContractHistory/`
        const contractHistoryRef = databaseRef(database, contractHistoryPath);

        // 今日の日付
        const nowDate = new Date()
        const nowYear = nowDate.getFullYear();
        const nowMonth = nowDate.getMonth();

        return get(contractHistoryRef)
            .then((snapshot) => {
                const histories = (snapshot.val())
                if(histories && Object.keys(histories).length != 0){
                    // 最新履歴キーを取得
                    const latestHistory = Math.max(...Object.keys(histories).map(Number));
                    
                    // プラン変更を実施していなければ、終了
                    if(histories[latestHistory].Action != 'プラン変更') return false;
                    // 最新履歴の契約開始日時(Date型)
                    const contractDate = new Date(histories[latestHistory].ContractStartDate);
                    // 今月中でなければ、終了
                    if(nowYear != contractDate.getFullYear() || 
                        nowMonth != contractDate.getMonth()) return false;
                    
                    // 今月の27日 9:00:00のDate型作成
                    const cutoff = new Date(
                        nowYear,
                        nowMonth,
                        27,
                        9, 0, 0, 0
                    );
                    // 最新履歴の契約開始日時が支払日後かチェック
                    // (支払日後に2回以上プラン変更するのはNG)
                    if(contractDate.getTime() > cutoff.getTime()){
                        return true
                    } else{
                        // 今月の支払日がまだであれば、支払日を待つ
                        return nowDate.getTime() <= cutoff.getTime()
                    }
                }
            })
            .catch((err) => {
                console.error('chkPlanChgCount error:', err);
                return false; // 失敗時は false を返す
            });
    }

    //プラン情報のモーダルを表示
    const showPlanModal = () => {
        // 今月の支払前にプラン変更してないか確認
        chkPlanChgCount().then((result) => {
            if(result){
                // プラン変更は月に1回までとする注意喚起を表示
                reactiveObj.modalMessage = `※プランの変更は月に一回までとなります。<br>（毎月27日9:00に再度変更可能となります）`
                reactiveObj.otherObject.confirm = ''
                showDefaultModal()
            }
            else{
                reactiveObj.planModalFlag = true
                reactiveObj.renderKey++
            }
        })
    }
    //プラン情報のモーダルを閉じる
    const closePlanModal = (editFlag, PlanObject) => {
        reactiveObj.planModalFlag = false
        //変更の有無
        if(editFlag) {
            reactiveObj.editCorporateInfo = PlanObject
            //現在のプラン名を取得
            const PlanName = reactiveObj.planInfo[PlanObject.PlanValue-1].PlanName
            //上位のプラン名を取得
            const afterPlanName = reactiveObj.planInfo[PlanObject.PlanValue].PlanName
            //月額/年額も一応
            const Payment = PlanObject.Payment ? PlanObject.Payment : '変更なし'
            reactiveObj.modalMessage = `プランを現在の${PlanName}から${afterPlanName}に変更します。よろしいですか？`
            reactiveObj.otherObject.confirm = 'OK'
            showDefaultModal()
            reactiveObj.renderKey++
        }
    }
    //モーダルを表示
    const showDefaultModal = () => {
        reactiveObj.modalFlag = true
        //モーダル部分を再描画
        // 画面全体を再レンダリングするとStripe elementsが初期化されてしまうので、モーダルだけを再描画する
        reactiveObj.modalRenderkey++
    }
    //モーダルを閉じる
    const closeDefaultModal = async(editFlag) => {
        reactiveObj.modalFlag = false

        const corporateInfoPath = `CorporateId/${reactiveObj.corporateId}/CorporateInfo/`
        const contractData = databaseRef(database, corporateInfoPath);

        // 今日の日時
        const currentDate = new Date()
        // 次回支払日(Date型)
        const nextPayDate = new Date(reactiveObj.corporateObject.EndExpectedDate);
        
        //変更の同意がありかつ、モーダル表示の追加オブジェクトがある場合
        if(editFlag && reactiveObj.otherObject.payKind)
        {
            // loading画面開始
            reactiveObj.loadindCardFlag = true;
            // Stripeへの登録
            const retRegStripe = await registStripe()

            if(!retRegStripe){
                alert(Error.errorResult({ code: 'CIE0001' }, route.name))
                
                // loading画面終了
                reactiveObj.loadindCardFlag = false;
                //モーダル表示の追加オブジェクトを破棄
                reactiveObj.otherObject.confirm = ''
                reactiveObj.otherObject.payKind = ''

                //変更情報の破棄
                reactiveObj.editCorporateInfo = {}
                reactiveObj.renderKey++
                return
            }
            // 支払方法変更時の設定
            if(reactiveObj.otherObject.payKind == 'RegistCard'){
                //今月支払の場合、今月→請求書、次月以降→カード支払いになるので、フラグを立てておく
                if(currentDate.getFullYear() == nextPayDate.getFullYear() &&
                    currentDate.getMonth() == nextPayDate.getMonth()) await update(contractData, {PayChgFlg:true})
                // 支払種別を更新
                await update(contractData, {PayKind:1})
            }
            //モーダル表示の追加オブジェクトを破棄
            reactiveObj.otherObject.confirm = ''
            reactiveObj.renderKey++
            // loading画面終了
            reactiveObj.loadindCardFlag = false;
            //確認用のモーダルを表示
            showDefaultModal()
        }
        else if(editFlag && reactiveObj.otherObject.confirm) {
            // 変更情報を更新する
            await update(contractData, reactiveObj.editCorporateInfo);
            // プランの変更の場合
            if(reactiveObj.editCorporateInfo?.PlanValue) {
                if(reactiveObj.corporateObject.Payment == 12){
                    // 新プランから旧プランを相殺するので、次回支払額を計算
                    const price = await setNextPriceYearPay(currentDate, nextPayDate)
                    // 年払いの場合、利用開始月の翌月払いなので支払日を2か月後に設定する
                    await update(contractData, {PayChgPrice: price, EndExpectedDate: new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 27).getTime()})   
                }

                //契約内容更新の履歴のオブジェクトを作成
                const contractHistory = {
                    [currentDate.getTime()]: {
                        "PlanValue": reactiveObj.editCorporateInfo.PlanValue,
                        "Action": "プラン変更",
                        "Payment": reactiveObj.corporateObject.Payment,
                        "Email": reactiveObj.corporateObject.Email,
                        "ContractNumber":`${reactiveObj.corporateObject.CorporateId}_${currentDate.getTime()}`,
                        "ContractStartDate": currentDate.getTime(),
                        "ContractPerson": reactiveObj.corporateObject.ContractPerson,
                    }
                }
                //契約内容情報の更新
                await update(child(contractData, 'ContractHistory'), contractHistory);
                reactiveObj.NextPlanValue = reactiveObj.corporateObject.PlanValue + 1 < Object.keys(reactiveObj.planInfo).length
                //プラン変更APIの実行
                utilFunctions.callFirebaseFunction('changePlan', {
                    corporateId: reactiveObj.corporateId,
                    contractEmail: reactiveObj.corporateObject.Email,
                    corporateName: reactiveObj.corporateObject.CorporateName,
                    userName: reactiveObj.corporateObject.ContractPerson,
                    oldPlan: reactiveObj.planInfo[reactiveObj.corporateObject.PlanValue-1].PlanName,
                    newPlan: reactiveObj.planInfo[reactiveObj.corporateObject.PlanValue].PlanName
                })
                //正常時（画面通知はなし）
                .then(() => {})
                //エラー時
                .catch((error) => {
                    showDefaultModal(Error.errorResult(error.details, route.name))
                })
            }
            reactiveObj.renderKey++
            //モーダル表示の追加オブジェクトを破棄
            reactiveObj.otherObject.confirm = ''
            //確認用のモーダルを表示
            showDefaultModal()
        }
        //モーダル表示の追加オブジェクトがない場合
        if(!reactiveObj.otherObject.confirm) {
            reactiveObj.modalMessage = `ご担当者情報を変更しました。`
            //プラン変更の場合はメッセージ内容を上書き
            if(reactiveObj.editCorporateInfo?.PlanValue) {
                reactiveObj.modalMessage = `プランを${reactiveObj.planInfo[reactiveObj.editCorporateInfo.PlanValue].PlanName}に変更しました。変更内容を記載したメールを送信しましたので、ご確認ください。`
            }
            // クレジットカード登録/変更の時もメッセージ内容を上書き
            else if(reactiveObj.otherObject.payKind == 'RegistCard')
            {
                reactiveObj.modalMessage = `クレジットカード情報を登録し、<br>支払い方法を変更しました。<br>翌月以降のお支払い時よりクレジットカード払いに変更となります。`
            }
            else if(reactiveObj.otherObject.payKind == 'ChangeCard')
            {
                reactiveObj.modalMessage = `クレジットカード情報を変更しました。`
            }
        }
        //モーダル表示の追加オブジェクトを破棄
        reactiveObj.otherObject.confirm = ''
        reactiveObj.otherObject.payKind = ''

        //変更情報の破棄
        reactiveObj.editCorporateInfo = {}
    }
    //支払方法のモーダルを表示
    const showPayModal = () => {
        reactiveObj.payModalFlag = true
    }
    const closePayModal = async(editFlag, payKind, cardname) => {
        reactiveObj.payModalFlag = false
        //変更の有無
        if(editFlag) {
            //カード情報を保存
            stripeObj.CardName = cardname
            if(payKind == 'RegistCard')
            {
                reactiveObj.modalMessage = `ご入力いただいた情報で登録し、<br>支払い方法をクレジットカード払いに<br>変更します。<br>よろしいですか？`
            }
            else if (payKind == 'ChangeCard')
            {
                reactiveObj.modalMessage = `クレジットカード情報を変更します。<br>よろしいですか？`
            }
            reactiveObj.otherObject.confirm = 'OK'
            reactiveObj.otherObject.payKind = payKind
            reactiveObj.otherObject.modalWidth = 100%
            showDefaultModal()
            // 画面全体を再レンダリングするとStripe elementsが初期化されてしまうので、レンダリングしない
        }
        else{
            // 処理キャンセルの時は画面全体を再レンダリング
            reactiveObj.renderKey++
        }
    }
    //コンポーネントがマウントされた後に実行
    onMounted(async () => {
        //企業コードを取得
        reactiveObj.corporateId = await utilFunctions.getCorporateId()
        reactiveObj.planInfo = await utilFunctions.getPlanInfo()
        //企業一覧を取得する
        await getCorporate(reactiveObj.corporateId)
        //Stripeの初期化
        await initStripe()
        reactiveObj.renderKey++
    })
</script>
<template>
    <!-- コメントアウト用 -->
    <HeaderComponent></HeaderComponent>
    <NavigationBar></NavigationBar>
    <main>
        <div id="loadingDisplay" class="loading" v-show="reactiveObj.loadingFlag">
            <div class="load-text load-blink">読み込み中...</div>
        </div>
        <div id="loadindCardDisplay" class="loading" v-show="reactiveObj.loadindCardFlag">
            <div class="load-text load-blink">処理中...</div>
        </div>
        <div class="contractInfo" v-show="!reactiveObj.loadingFlag" :key="`${reactiveObj.renderKey}`">
            <div class="titleArea">
                <p class="title">契約詳細</p>
            </div>
            <div class="tableArea">
                <div class="alertMessage">
                    <p v-show="reactiveObj.corporateObject.limitUserFlag" :style="{ color: `${reactiveObj.corporateObject.limitUserFlag ? '#ff0000' : '#000000'}`, 'font-weight': `${reactiveObj.corporateObject.limitUserFlag ? 'bold' : '100'}`}">
                        {{ reactiveObj.dataLoadFlag ? (reactiveObj.corporateObject.remainingUserCount >= 0 ? `登録ユーザー数が上限に近づいています。(残り${reactiveObj.planInfo[reactiveObj.corporateObject.PlanValue].LimitUserCount - reactiveObj.corporateObject.UserCount}名)` : `登録ユーザー数が上限を超過しています。(${Math.abs(reactiveObj.corporateObject.remainingUserCount)}名の超過)`) : '' }}
                    </p>
                    <p v-show="reactiveObj.corporateObject.limitTerminalFlag" :style="{ color: `${reactiveObj.corporateObject.limitTerminalFlag ? '#ff0000' : '#000000'}`, 'font-weight': `${reactiveObj.corporateObject.limitTerminalFlag ? 'bold' : '100'}`}">
                        {{ reactiveObj.dataLoadFlag ? (reactiveObj.corporateObject.remainingTerminalCount >= 0 ? `登録デバイス数が上限に近づいています。(残り${reactiveObj.planInfo[reactiveObj.corporateObject.PlanValue].LimitTerminalCount - reactiveObj.corporateObject.TerminalCount}台)` : `登録デバイス数が上限を超過しています。(${Math.abs(reactiveObj.corporateObject.remainingTerminalCount)}台の超過)`) : '' }}
                    </p>
                </div>
                <table class="detailTable">
                    <tbody>
                        <tr>
                            <td class="leftText">企業名</td>
                            <td class="rightText">{{ reactiveObj.dataLoadFlag ? reactiveObj.corporateObject.CorporateName : '' }}</td>
                            <td class="lastText" colspan="2">
                            </td>
                        </tr>
                        <tr>
                            <td class="leftText">企業コード</td>
                            <td class="rightText">{{ reactiveObj.dataLoadFlag ? reactiveObj.corporateObject.CorporateId : '' }}</td>
                            <td class="lastText" colspan="2">
                            </td>
                        </tr>
                        <tr>
                            <td class="leftText">ご担当者様</td>
                            <td class="rightText">
                                {{ reactiveObj.dataLoadFlag ? reactiveObj.corporateObject.ContractPerson : '' }}<br>
                                {{ reactiveObj.dataLoadFlag ? reactiveObj.corporateObject.Email : '' }}
                            </td>
                            <td class="lastText" colspan="2">
                                <button id="editPerson" @click="showPersonModal" v-show="reactiveObj.dataLoadFlag ? true : false">変更</button>
                            </td>
                        </tr>
                        <tr>
                            <td class="leftText">ご利用中のプラン</td>
                            <td class="rightText">
                                {{ reactiveObj.dataLoadFlag ? reactiveObj.planInfo[reactiveObj.corporateObject.PlanValue].PlanName : '' }}<br>
                                {{ reactiveObj.dataLoadFlag ? `${reactiveObj.corporateObject.Payment == 1 ? '月' : '年'}払い（次回お支払い：${formatToTimeZone(reactiveObj.corporateObject.EndExpectedDate, DATEFORMAT, { timeZone: TIME_ZONE_TOKYO })}）` : '' }}
                            </td>
                            <td class="lastText" colspan="2">
                                <button id="editPlan" @click="showPlanModal" v-show="reactiveObj.dataLoadFlag ? (reactiveObj.corporateObject.PlanValue == Object.keys(reactiveObj.planInfo).length -1 ? false : true) : false">変更</button>
                            </td>
                        </tr>
                        <tr>
                            <td class="leftText">お支払い方法</td>
                            <td class="rightText">
                                <span class="paykind-wrapper">
                                    {{ reactiveObj.dataLoadFlag && reactiveObj.corporateObject.PayKind
                                        ? paykindDict[reactiveObj.corporateObject.PayKind]
                                        : '請求書払い' }}
                                    <span v-if="isInvoicePayment()" class="paykind-tips-wrapper">
                                        <img @mouseenter="tipsPayFlag = true" @mouseleave="tipsPayFlag = false" @click.stop="tipsPayFlag = !tipsPayFlag" src="../../assets/tips_icon.svg" class="tips-icon">
                                        <span class="tips-content" v-show="tipsPayFlag">変更ボタンから、クレジットカード支払いに変更できます</span>
                                    </span>
                                </span><br>
                                {{ reactiveObj.dataLoadFlag && reactiveObj.corporateObject.CreditNumber
                                    ? `登録カード：**** **** **** ${reactiveObj.corporateObject.CreditNumber}`
                                    : '' }}
                            </td>
                            <td class="lastText" colspan="2">
                                <button id="editPaykind" @click="showPayModal">変更</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="registerInfo" v-show="!reactiveObj.loadingFlag" :key="`${reactiveObj.renderKey}`">
            <div class="titleArea">
                <p class="title">ご利用状況</p>
            </div>
            <div class="tableArea">
                <table class="detailTable">
                    <tbody>
                        <tr>
                            <td class="leftText">登録ユーザー数</td>
                            <td class="rightText" :style="{ color: `${reactiveObj.corporateObject.limitUserFlag ? '#ff0000' : '#000000'}`, 'font-weight': `${reactiveObj.corporateObject.limitUserFlag ? 'bold' : '100'}`, 'border-color': '#000000'}">
                                {{ reactiveObj.dataLoadFlag ? `${reactiveObj.corporateObject.UserCount} 名（現在のプランの上限： ${reactiveObj.planInfo[reactiveObj.corporateObject.PlanValue].LimitUserCount} 名）` : '' }}
                            </td>
                            <td class="lastText" colspan="2">
                            </td>
                        </tr>
                        <tr class="notButtom">
                            <td class="leftText">登録デバイス数</td>
                            <td class="rightText" :style="{ color: `${reactiveObj.corporateObject.limitTerminalFlag ? '#ff0000' : '#000000'}`, 'font-weight': `${reactiveObj.corporateObject.limitTerminalFlag ? 'bold' : '100'}`, 'border-color': '#000000'}">
                                {{ reactiveObj.dataLoadFlag ? `${reactiveObj.corporateObject.TerminalCount} 台（現在のプランの上限：${reactiveObj.planInfo[reactiveObj.corporateObject.PlanValue].LimitTerminalCount} 台）` : '' }}
                            </td>
                            <td class="lastText" colspan="2">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <router-link class="nav-link" to="/request">退会申請 ＞</router-link>
            <DefaultModalComponent
                :key="reactiveObj.modalRenderkey"
                :modalMessage="reactiveObj.modalMessage"
                :otherObject="reactiveObj.otherObject"
                v-show="reactiveObj.modalFlag"
                @executeMethod="closeDefaultModal">
            </DefaultModalComponent>
            <EditPersonComponent
                :key="reactiveObj.renderKey"
                :PersonObject="{
                    ContractPerson: reactiveObj.corporateObject.ContractPerson,
                    Email: reactiveObj.corporateObject.Email
                }"
                v-show="reactiveObj.personModalFlag"
                @executeMethod="closePersonModal">
            </EditPersonComponent>
            <EditPlanComponent
                :key="reactiveObj.renderKey"
                :PlanObject="{
                    PlanValue: reactiveObj.corporateObject.PlanValue,
                    Payment: reactiveObj.corporateObject.Payment,
                    PlanInfo: reactiveObj.planInfo,
                    NextPlanValue: reactiveObj.NextPlanValue
                }"
                v-show="reactiveObj.planModalFlag"
                @executeMethod="closePlanModal">
            </EditPlanComponent>
            <EditPayComponent
                :PayObject="{
                    Kind: reactiveObj.corporateObject.CreditNumber ? 'ChangeCard' : 'RegistCard',
                }"
                :cardNumberElement="stripeObj.cardNumberElement"
                :cardExpiryElement="stripeObj.cardExpiryElement"
                :cardCvcElement="stripeObj.cardCvcElement"
                v-show="reactiveObj.payModalFlag"
                @executeMethod="closePayModal">
            </EditPayComponent>
        </div>
    </main>
</template>

<style scoped>
    .contractInfo  {
        padding: 0 5% 0 25%;
        background-color: #e7e6e6;
    }
    .registerInfo{
        padding: 5% 5% 0 25%;
        background-color: #e7e6e6;
    }
    #back {
        position: absolute;
        top: 5%;
        cursor: pointer;
    }
    #sortButton {
        color: #FFFFFF;
        position: relative;
        display: flex;
        margin-left: auto;
        top: -40px;
        border: solid 3px #00AEEB;
        background: #00AEEB;
    }
    .commonTable td {
        border-color: black;
        cursor: pointer;
    }
    .commonTable {
        border-color: black;
        th {
            cursor: pointer;
            position: relative;
        }
    }
    .alertMessage {
        padding: 0 0 20px 0;
    }
    .detailTable {
        width: 100%;
        margin: 0 0 0 0;
        border-collapse: collapse;
        border: none;
        tr {
            height: 60px;
        }
        td {
            background: #dbdbdb;
            border-left: solid 1px;
            border-top: solid 1px;
        }
        td:first-child {
            border-left: none;
        }
        td:last-child {
            border-left: none;
        }
        tr:first-child td {
            border-top: none;
        }
        tr:first-child>*:first-child{
            border-radius: 20px 0 0 0;
        }
        tr:first-child>*:last-child{
            border-radius: 0 20px 0 0;
        }
        tr:last-child>*:last-child{
            border-radius: 0 0 20px 0;
        }
        tr:last-child>*:first-child{
            border-radius: 0 0 0 20px;
        }
        tr:nth-child(odd) td {
            background: #c4c4c4;
        }
        .leftText {
            width: 30%;
            text-align: left;
            left: 20px;
            padding: 0 0 0 20px;
        }
        .rightText {
            width: 60%;
            text-align: left;
            left: 20px;
            padding: 0 0 0 20px;
        }
        .lastText {
            width: 10%;
            text-align: center;
            padding: 0 10px 0 0;
        }
        #editPerson, #editPlan, #editPaykind {
            background-color: #00AEEB;
            color: #FFFFFF;
            border: none;
            width: 75px;
            height: 40px;
        }
    }
    .paykind-wrapper {
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }
    .paykind-tips-wrapper {
        position: relative;
        display: inline-flex;
        align-items: center;
    }
    .tips-icon {
        cursor: pointer;
        vertical-align: middle;
        width: 18px;
        height: 18px;
    }
    .tips-content {
        position: absolute;
        bottom: calc(100% + 8px);
        left: 50%;
        transform: translateX(-50%);
        background-color: gray;
        color: white;
        border-radius: 0.5em;
        padding: 5px 10px;
        white-space: normal;
        width: 200px;
        text-align: center;
        font-size: 13px;
        z-index: 10;
    }
    .tips-content:before {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -12px;
        border: 12px solid transparent;
        border-top: 12px solid gray;
    }
    .nav-link {
        position: relative;
        top: 30px;
        left: 45%;
    }
    @media (max-width: 1150px) {
        .contractInfo {
            padding: 0 5% 0 5%;
        }
        .registerInfo {
            padding: 5% 5% 0 5%;
        }
        #editContract, #editPlan {
            width: 75px;
            background-color: #00AEEB;
            color: #FFFFFF;
            border: none;
        }
    }
</style>
